import { metaKey } from '~/scripts/utils';
import { pick } from 'lodash';

export default async ({ $api, app, $cookies, redirect, route, store }) => {
  const id = $cookies.get('bonkers-ie-home-insurance-search');
  const address = $cookies.get('bonkers-ie-home-insurance-capture-point');
  const uuid = route.params.uuid;
  const params = {};
  const searchRequired = metaKey(route, 'searchRequired');

  store.commit('products/setBasePath', '/compare-home-insurance/');

  if (!id && !uuid) {
    if (searchRequired) {
      return redirect(301, app.localePath('/compare-home-insurance/'), {
        flashClass: 'error',
        flashMessage: store.$i18n.t('errors.homeInsuranceSearchNotFound')
      });
    }
    if (address) {
      store.commit('search/reset', { type: 'homeInsurance' });
      store.commit('search/set', { address });
      store.commit('utils/setAddress', address);
    } else {
      store.commit('search/reset', { type: 'homeInsurance' });
    }
    return;
  }

  if (uuid) {
    params.reminder = true;
  }

  await $api(`protection/home_insurance_searches/${uuid || id}`, params).then(search => {
    if (metaKey(route, 'removeQuotes')) {
      store.commit('products/clear');
    } else {
      store.commit('products/setList', search.quotes);
    }
    delete search.quotes;
    store.commit('search/reset', { type: 'homeInsurance', search });
    store.commit('search/setTemp', pick(search, ['claimExcess']));
    route.meta[0] = { ...route.meta[0], jumbotronParams: { amount: store.$i18n.n(search.contents_cover, 'currencyRound') } };
  }).catch(e => {
    if (uuid && e.response.status === 404) {
      route.meta[0] = { ...route.meta[0], jumbotronScope: 'compare-home-insurance.confirm-search' };
      return;
    }
    $cookies.remove('bonkers-ie-home-insurance-search');
    store.commit('search/reset', { type: 'homeInsurance' });
  });
};
